import { Card, Col, Form, Input, Row } from 'antd'
import React from 'react'
import AgreementSignerItemFields from './AgreementSignerItemFields'

function AgreementSignerItem({ title }) {
  return (
    <>
      <Card style={{ paddingLeft: 22, paddingRight: 22 }}>

        <h3>{title}</h3>
        <hr style={{ borderBottom: "1px Solid var(--hr-color)", marginTop: 6, marginBottom: 14 }} />
        <p>Add all parties that must sign this agreement associated with {title}.</p>

        <AgreementSignerItemFields />

      </Card>
      <br />
    </>
  )
}

export default AgreementSignerItem